<template>
  <div>
    <div>
      <file-form
        :fileContentType="fileContentType"
        :contactLookupsOptions="contactLookupsData"
        :upload-file-function="uploadFileFunction"
      />
    </div>
    <grid
      has-pagination
      grid-id="files-grid"
      :fields="fields"
      :filters="filtersObjArr"
      :get-items-function="getFilesData"
      :items="filesData"
      :no-records="'No associated files found'"
      :indicator="getStatus"
      :total-rows="filesPaging.totalItems"
      :current-page="filesPaging.pageNumber"
      :per-page="filesPaging.pageSize"
      :sort-by="filesPaging.sortBy"
      :sort-order="filesPaging.sortOrder"
    />
  </div>
</template>

<script>
import Grid from '../Grid';
import { mapState, mapActions, mapGetters } from 'vuex';
import FileForm from './Form';

export default {
  components: {
    Grid,
    FileForm
  },
  props: [
    'getFilesFunction',
    'uploadFileFunction',
    'filesData',
    'filesPaging',
    'fileContentType',
    'contactLookupsData',
  ],
  data() {
    return {
      fields: [
        {
          key: 'fileStatusCommand',
          label: '',
          tdClass: 'grid-commands-width-1',
          fileComponent: 'FileAction'
        },
        { key: 'friendlyName', label: 'Friendly Name' },
        { key: 'filePassword', label: 'Password' },
        { key: 'fileCategory', label: 'Content Type' },
        { key: 'fileName', label: 'File Name' },
        { key: 'verification', label: 'Verification' },
        { key: 'uploadedBy', label: 'Uploaded By' },
        {
          key: 'dateCreated',
          label: 'Date Uploaded',
          formatter: 'dateFormatter'
        },
        { key: 'notifiedUsers', label: 'Notified Users' },
        { key: 'fileExtension', label: 'Filetype' },
        { key: 'fileSize', label: 'Size' }
      ],
      filtersObjArr: [
        {
          type: 'search',
          name: 'Friendly Name',
          fieldName: 'friendlyName'
        },
        {
          type: 'search',
          name: 'Content Type',
          fieldName: 'fileCategory'
        },
        {
          type: 'search',
          name: 'File Name',
          fieldName: 'fileName'
        },
        {
          type: 'search',
          name: 'Uploaded By',
          fieldName: 'uploadedBy'
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getFilesData(data) {
      await this.getFilesFunction(data);
    },
    getStatus(data) {
      let indicators = '';
      if (data.item.verification === 'Auto' && !data.item.isVerified) {
        indicators =
          '<i class="grid-commands-icon-search fa fa-search fa-fw mr-2" @click="fileView(data)"></i>';
      } else if (data.item.isVerified) {
        indicators =
          '<i class="grid-commands-icon-search fa fa-file fa-fw mr-2"></i>' +
          '<i class="grid-commands-icon-search fa fa-search fa-fw mr-2"></i>';
      }

      return indicators;
    }
  }
};
</script>
